import { useRef } from 'react'

import type { Currency } from '../../sdk'
import { useOnChainPairData, type OnChainPairData } from './useOnChainPairData'

/**
 * Mantiene la última cotización válida mientras multicall re-sincroniza tras recarga o foco.
 * Evita flashes de "Cargando…" en la UI móvil cuando ya había datos on-chain.
 */
export function useStableOnChainPairData(
  tokenA: Currency | null | undefined,
  tokenB: Currency | null | undefined,
): OnChainPairData {
  const pairData = useOnChainPairData(tokenA, tokenB)
  const stableRef = useRef<OnChainPairData>(pairData)

  if (!pairData.loading && pairData.exists) {
    stableRef.current = pairData
  }

  if (pairData.loading && stableRef.current.exists) {
    return { ...stableRef.current, loading: false }
  }

  return pairData
}
